'use strict';

var d3 = require('d3');
var _ = require('lodash');
var drawUtils = require('../utils/drawUtils');
var d3InterpolatePath = require('d3-interpolate-path');

var ppSplines = {};

ppSplines.constructor = function (props) {
  //console.log('constructor ppSplines:', props);

  ppSplines.svgPath = d3.line().x(function (d) {
    return d.x;
  }).y(function (d) {
    return d.y;
  }).curve(d3.curveMonotoneX);

  ppSplines.fps = Math.round(1000 / 30);

  ppSplines.showToolTip = props.showToolTip;
  ppSplines.toolTipPosition = props.toolTipPosition;
  ppSplines.removeToolTip = props.removeToolTip;
  ppSplines.d3CHS = props.d3CHS;
  ppSplines.cohortSelector = props.cohortSelector;
};

ppSplines.updatePatients = function (props) {

  //console.log(props);
  ppSplines.virtualDomContainer = props.virtualDomContainer;
  ppSplines.gSvgSplines = props.gSvgSplines;
  ppSplines.canvas = props.canvas;
  ppSplines.context = props.context;

  var pathsData = {
    backGround: { id: 'background', paths: [] },
    forGround: { id: 'forground', paths: [] },
    activePatient: { id: 'current', paths: [] }
  };

  var activePatientID = false;
  if (props.activePatient) activePatientID = props.activePatient.features.patientID;

  _.each(props.patientsIdMap, function (d) {
    d.paralelPlot.path = _.sortBy(d.paralelPlot.path, function (o) {
      return o.x;
    });

    var similar = _.find(props.similarPatientsFilter.patients, function (o) {
      return o.patientID === d.features.patientID;
    });

    d.activePatient = false;
    if (d.features.patientID === activePatientID) {
      d.activePatient = true;
      pathsData.activePatient.paths.push(d);
    } else if (similar) {
      d.similar = true;
      pathsData.forGround.paths.push(d);
    } else {
      d.similar = false;
      pathsData.backGround.paths.push(d);
    }

    if (ppSplines.cohortSelector) {
      if (d.paralelPlot.path[0].column !== 'cohortSelector') {
        var p0 = ppSplines.d3CHS.getP0vertex(d.features.cohortIndex);
        var vertex = [{ x: p0.x, y: p0.y, column: 'cohortSelector' }];
        d.paralelPlot.path = _.concat(vertex, d.paralelPlot.path);
      }
    }
  });

  var gPathsData = [];
  gPathsData = _.concat(gPathsData, pathsData.backGround.paths);
  gPathsData = _.concat(gPathsData, pathsData.forGround.paths);
  gPathsData = _.concat(gPathsData, pathsData.activePatient.paths);

  var svgMousePathsData = [];
  if (props.activePatient) {
    svgMousePathsData = pathsData.activePatient.paths;
  }

  var perc = props.similarPatientsFilter.patients.length / props.totalNRPatients;
  //path stroke width
  var wSimilar = 0.1 + (0.25 - perc * 0.25);
  if (props.similarPatientsFilter.patients.length < 10) wSimilar = 1;

  var dataBinds = ppSplines.virtualDomContainer.selectAll('custom.path').data(gPathsData, function (d) {
    return d.features.patientID;
  });

  dataBinds.enter().append('custom').classed('path', true).attr('d', function (d) {
    return ppSplines.svgPath(d.paralelPlot.path);
  }).each(function (d, i) {

    ppSplines.setPathProps(d3.select(this), d, props.similarPatientsFilter, wSimilar);
    if (i === gPathsData.length - 1) {
      ppSplines.updateCanvas('append');
      ppSplines.setSVGMouseTargetPaths(svgMousePathsData, props.tweenTime);
    }
    ;
  });

  dataBinds.transition().duration(props.tweenTime).attrTween('d', function (d, i) {
    var el = d3.select(this);

    //get previous path attrs
    var pPath = el.attr('d');
    var pStroke = el.attr('stroke');
    var pStrokeWidth = el.attr('stroke-width');

    //update path props
    ppSplines.setPathProps(el, d, props.similarPatientsFilter, wSimilar);

    var nPath = void 0;
    if (props.vertexUpdate) {
      nPath = ppSplines.svgPath(d.paralelPlot.path);
    } else {
      nPath = el.attr('d');
    }

    var nStroke = el.attr('stroke');
    var nStrokeWidth = el.attr('stroke-width');

    //set interpolators
    var iPath = d3InterpolatePath.interpolatePath(pPath, nPath);
    var iStroke = d3.interpolateRgb(pStroke, nStroke);
    var iStrokeWidth = d3.interpolateNumber(pStrokeWidth, nStrokeWidth);

    return function (t) {
      el.attr('stroke', iStroke(t));
      el.attr('stroke-width', iStrokeWidth(t));
      if (i === gPathsData.length - 1) {
        ppSplines.updateCanvas('interpolate');
      }
      return iPath(t);
    };
  }).on('start', function (d, i) {
    if (i === 0) {
      ppSplines.updateCanvas('start');
    }
    ;
  }).on('end', function (d, i) {
    if (i === gPathsData.length - 1) {
      ppSplines.updateCanvas('end');
      ppSplines.setSVGMouseTargetPaths(svgMousePathsData, props.tweenTime);
    }
  });

  dataBinds.exit().remove();
};

ppSplines.setSVGMouseTargetPaths = function (gPathsData, tweenTime) {

  //Bigest performance isseu, needs refectoring
  //if(!props.realTimeUpdate) return;

  var svgMouseTargetPaths = ppSplines.gSvgSplines.selectAll('#svg-spline').data(gPathsData, function (d) {
    return d.features.patientID;
  });

  svgMouseTargetPaths.enter().append('path').attr('id', 'svg-spline').attr('key', function (d) {
    //console.log(d);
    return 'currentPatient';
  }).attr('d', function (d) {
    return ppSplines.svgPath(d.paralelPlot.path);
  }).attr('fill', 'none').attr('stroke', function (d) {
    var c = drawUtils.colors.similarPatients.filter;
    if (d.activePatient) c = drawUtils.colors.similarPatients.activePatient;
    return c;
  }).attr('stroke-width', function (d) {
    var w = 2;
    if (d.activePatient) w = 4;
    return w;
  }).attr('opacity', 0).style("stroke-linecap", "round").on('mouseover', function (d) {
    d3.select(this).attr('opacity', 1);
    ppSplines.showToolTip(d, true);
  }).on('mouseout', function (d) {
    d3.select(this).attr('opacity', 0);
    ppSplines.removeToolTip();
  }).on("mousemove", function () {
    ppSplines.toolTipPosition();
  });

  svgMouseTargetPaths.attr('d', function (d) {
    return ppSplines.svgPath(d.paralelPlot.path);
  });

  svgMouseTargetPaths.exit().remove();
};

ppSplines.setPathProps = function (el, d, similarPatientsFilter, wSimilar) {

  el.attr('stroke-width', function () {
    var w = 0.15;
    if (similarPatientsFilter.filtersActive) w = 0.1;
    if (d.similar) w = wSimilar;
    if (d.activePatient) w = 4;
    d.paralelPlot['stroke-width'] = w;
    return w;
  }).attr('stroke', function () {
    var c = drawUtils.colors.similarPatients.default;
    if (ppSplines.cohortSelector) {
      c = ppSplines.d3CHS.getCohortColor(d.features.cohortIndex);
    }
    if (similarPatientsFilter.filtersActive) c = drawUtils.colors.similarPatients.deSelected;

    if (d.similar) {
      c = drawUtils.colors.similarPatients.selected;
      //c = d.style.fill
      if (ppSplines.cohortSelector) {
        c = ppSplines.d3CHS.getCohortColor(d.features.cohortIndex);
      }
    }

    if (d.activePatient) c = drawUtils.colors.similarPatients.activePatient;
    d.paralelPlot['stroke'] = c;
    return c;
  }).style("stroke-linecap", "round");
};

ppSplines.setCanvasTransitions = function (transitionState) {

  if (transitionState === 'start') {
    ppSplines.interval = d3.interval(function () {
      ppSplines.updateCanvas('update');
    }, ppSplines.fps);
  } else if (transitionState === 'end') {
    ppSplines.interval.stop();
    ppSplines.interval = null;
  }
};

ppSplines.updateCanvas = function (transitionState) {

  ppSplines.context.fillStyle = "#fff";
  ppSplines.context.fillRect(0, 0, ppSplines.canvas.attr('width'), ppSplines.canvas.attr('height'));

  var splines = ppSplines.virtualDomContainer.selectAll('custom.path');

  splines.each(function (d) {
    var p = d3.select(this);
    var path2D = new Path2D(d3.select(this).attr('d'));
    ppSplines.context.beginPath();
    ppSplines.context.lineWidth = p.attr('stroke-width');
    ppSplines.context.strokeStyle = p.attr('stroke');
    ppSplines.context.stroke(path2D);
  });
};

module.exports = ppSplines;